import {message} from "../../../../utils/message";
import {CUSTOM_CONFIG} from "../../../../config/customConfig";
export const handleStatus = [
    {key: "", name: "全部"},
    {key: 1, name: "待解决"},
    {key: 2, name: "待核验"},
    {key: 3, name: "核验通过"},
    {key: 0, name: "已忽略"}
]

// 提醒状态颜色
export const remindStatusColors = {
    "IGNORED": "#CCCCCC",
    "NOT_REMIND": "#F56C6C",
    "REMINDED": "#89D069",
};

// 处理状态颜色
export const handleStatusColors = {
    "IGNORED": "#CCCCCC",
    "WAIT_PROCESSED": "#F56C6C",
    "WAIT_CHECK": "#F56C6C",
    "CHECK_PASS": "#89D069",
    "CHECK_NO_PASS": "#F56C6C",
    "NO_PROBLEM": "#FF1313",
    "Processing": "#B684F2",
    "HIGH": "#f5222d",
    "MIDDLE": "#fa541c",
    "LOW": "#faad14",
    "SENSITIVE": "#eb2f96",
    "PRIVACY": "#f5222d",
    "FALLENOFFICIAL": "#fa541c",
    "BLACKLINK": "#F56C6C"
};

export const colorByRemindType = {
    0: remindStatusColors["IGNORED"],
    1: remindStatusColors["NOT_REMIND"],
    2: remindStatusColors["REMINDED"],
};

export const colorByHandleStatusType = {
    0: handleStatusColors["IGNORED"],
    1: handleStatusColors["WAIT_PROCESSED"],
    2: handleStatusColors["Processing"],
    3: handleStatusColors["CHECK_PASS"],
    4: handleStatusColors["CHECK_NO_PASS"],
    5: handleStatusColors["NO_PROBLEM"],
};

export const colorByRiskLevel = {
    "high": handleStatusColors["HIGH"],
    "middle": handleStatusColors["MIDDLE"],
    "low": handleStatusColors["LOW"],
};

export const colorBySecurityType = {
    "sensitive": handleStatusColors["SENSITIVE"],
    "privacy": handleStatusColors["PRIVACY"],
    "fallenOfficial": handleStatusColors["FALLENOFFICIAL"],
    "corrupt_official": handleStatusColors["FALLENOFFICIAL"],
    "blacklink": handleStatusColors["BLACKLINK"],
};

export const getColorByRemindType = (state) => {
    return colorByRemindType[state] || remindStatusColors["IGNORED"];
};

export const getColorByHandleType = (state) => {
    return colorByHandleStatusType[state] || handleStatusColors["IGNORED"];
};

export const getColorByRiskLevel = (state) => {
    return colorByRiskLevel[state] || colorByRiskLevel["IGNORED"];
};

export const getColorBySecurityType = (state) => {
    return colorBySecurityType[state] || colorBySecurityType["IGNORED"];
};

// 提交处理结果
export const submitHandleResult = (record, btnItem, that) => {
    let body = [];
    record?.positionSecurityList?.length && record.positionSecurityList.map(item => {
        body.push({
            id: item.securityId,
            disposeStatus: item.disposeStatus,
            safetyId: record.id
        })
    })
    updateSonStatus(body, btnItem, record, that);
}

// 详情底部按钮  全部忽略、审核通过、审核不通过统一处理方法
export const allHandle = (record, btnItem, that) => {
    let body = [];
    record?.positionSecurityList?.length && record.positionSecurityList.map(item => {
        body.push({
            id: item.securityId,
            disposeStatus: btnItem.sonChangeValue,
            safetyId: record.id
        })
    })
    updateSonStatus(body, btnItem, record, that);
}

// 主列表操作变化
export const changeHomeListStatus = (record, btnItem, that) => {
    let body = {ids: record.id, status: btnItem.mainChangeValue}
    that.request({
        url: '/cm-sites-media-consumer/safety/management/batchUpdateStatus',
        body: body,
        method: "post",
        callBack: (data) => {
            if (data) {
                message.success(`${btnItem.name}成功`);
                if(typeof CUSTOM_CONFIG?.CUSTOM_CONTENT_SAFETY?.BATCHUPDATESTATUS_AFTERFUN==='function'){
                    record.mainChangeValue=btnItem.mainChangeValue;
                    void CUSTOM_CONFIG?.CUSTOM_CONTENT_SAFETY?.BATCHUPDATESTATUS_AFTERFUN(that,record,()=>{
                        if(that.getListData){
                            that.getListData();
                        } else{
                            that.props&&that.props.refreshList&&that.props.refreshList();
                        }
                    })
                }else{
                    if(that.getListData){
                        that.getListData();
                    } else{
                        that.props&&that.props.refreshList&&that.props.refreshList();
                    }
                }

            } else {
                message.error(`${btnItem.name}失败`);
            }
        },
        errorCallBack: (e) => {
        },
    })
}

export const updateSonStatus = (body, btnItem, record, that) => {
    that.request({
        url: '/cm-sites-media-consumer/safety/management/updateStatus',
        body: body,
        method: "post",
        contentType: "json",
        callBack: (data) => {
            if (data) {
                updateMainStatus(record, btnItem, that);
            } else {
                message.success(`${btnItem.name}成功`);
                that.refreshList();
            }
        },
        errorCallBack: (e) => {
        },
    })
}

export const updateMainStatus = (record, btnItem, that) => {
    let body = [{
        id: record.id,
        disposeStatus: btnItem.mainChangeValue
    }]
    that.request({
        url: '/cm-sites-media-consumer/safety/management/updateSafetyStatus',
        body: body,
        method: "post",
        contentType: "json",
        callBack: (data) => {
            if (data) {
                message.success(`${btnItem.name}成功`);
                if(typeof CUSTOM_CONFIG?.CUSTOM_CONTENT_SAFETY?.UPDATESAFETYSTATUS_AFTERFUN==='function'){
                    void CUSTOM_CONFIG?.CUSTOM_CONTENT_SAFETY?.UPDATESAFETYSTATUS_AFTERFUN(that,record,()=>{
                        that.refreshList()
                    })
                }else{
                    that.refreshList()
                }
            }
        },
        errorCallBack: (e) => {
        },
    })
}

// 0 已忽略   1 待处理    2 待核验   3 核验通过   4 核验不通过   5 非问题
// 1  未提醒   2  已提醒
// pms首页列表按钮
export const getPmsListBtn = [
    {
        key: "remind",
        name: "提醒处理",
        type: 2,
        component: 'text',
        showFun: (record, btnItem, that) => {
            let remindStatus = record.remindStatus;
            let disposeStatus = record.disposeStatus;
            return remindStatus === 1 && (disposeStatus === 1 || disposeStatus === 4);
        },
        onClick: (record, btnItem, that) => {
            that.remark.show(record, btnItem, () => {
                that.getListData();
            });
        }
    },
    {
        key: "redoRemind",
        name: "重新提醒",
        type: 2,
        component: 'text',
        showFun: (record, btnItem, that) => {
            let remindStatus = record.remindStatus;
            let disposeStatus = record.disposeStatus;
            return remindStatus === 2 && (disposeStatus === 1 || disposeStatus === 4);
        },
        onClick: (record, btnItem, that) => {
            that.remark.show(record, btnItem, () => {
                that.getListData();
            });
        }
    },
    {
        key: "verify",
        name: "核验",
        type: 2,
        component: 'textPopover',
        btnList: [
            {
                key: "handleAndSubmit",
                name: "核验通过",
                mainChangeValue: 3,
                onClick: (record, btnItem, that) => {
                    changeHomeListStatus(record, btnItem, that)
                }
            },
            {
                key: "noProblemAndSubmit",
                name: "核验不通过",
                mainChangeValue: 4,
                onClick: (record, btnItem, that) => {
                    changeHomeListStatus(record, btnItem, that)
                }
            }
        ],
        showFun: (record, btnItem) => {
            let disposeStatus = record.disposeStatus;
            return disposeStatus === 2;
        },
    },
    {
        key: "ignore",
        name: "忽略",
        type: 2,
        component: 'text',
        mainChangeValue: 0,
        showFun: (record, btnItem) => {
            let disposeStatus = record.disposeStatus;
            return disposeStatus === 1;
        },
        onClick: (record, btnItem, that) => {
            changeHomeListStatus(record, btnItem, that)
        }
    },
    {
        key: "link",
        name: "原文链接",
        type: 2,
        component: 'text',
        onClick: (record, btnItem, that) => {
            window.open(record.url);
        }
    },
    {
        key: "view",
        name: "查看详情",
        type: 2,
        component: 'text',
        onClick: (record, btnItem, that) => {
            that.detail.show(record.id, () => {
                that.getListData();
            })
        }
    },
]

// 0 已忽略   1 待处理    2 待核验   3 核验通过   4 核验不通过   5 非问题
// pms查看详情弹窗底部按钮
export const getPmsDetailBottomBtn = (that) => {
    return [
        {
            key: "remind",
            name: "提醒处理",
            type: 2,
            component: 'normalButton',
            mainChangeValue: (() => {
                let remindStatus = that.state.detailData.remindStatus;
                // 未提醒状态 && 存在核验不通过问题  ====》  将整体状态变为核验不通过，否则用原来的状态
                if(remindStatus === 1 && that.state.detailData?.positionSecurityList.some(item => item.disposeStatus === 4)) {
                    return 4;
                }
                return that.state.detailData.disposeStatus;
            })(),
            showFun: (record, btnItem) => {
                let remindStatus = record.remindStatus;
                let positionSecurityList = record?.positionSecurityList || [];
                // 未提醒状态 && （存在待处理问题 || 存在核验不通过问题） ===》   显示提醒处理按钮
                return remindStatus === 1 && (positionSecurityList.some(item => item.disposeStatus === 1) || positionSecurityList.some(item => item.disposeStatus === 4));
            },
            onClick: (record, btnItem, that) => {
                that.remark.show(record, btnItem, () => {
                    submitHandleResult(record, btnItem, that);
                });
            }
        },
        {
            key: "redoRemind",
            name: "重新提醒",
            type: 2,
            component: 'normalButton',
            mainChangeValue: (() => {
                let remindStatus = that.state.detailData.remindStatus;
                // 已提醒状态 && 存在核验不通过问题 && 不存在待核验问题  ====》  将整体状态变为核验不通过，否则用原来的状态
                if(remindStatus === 2 && (that.state.detailData?.positionSecurityList || []).some(item => (item.disposeStatus === 4 && item.disposeStatus !== 2 && item.disposeStatus !== 5))) {
                    return 4;
                }
                return that.state.detailData.disposeStatus;
            })(),
            showFun: (record, btnItem) => {
                let remindStatus = record.remindStatus;
                let positionSecurityList = record?.positionSecurityList || [];
                // 已提醒状态 && （存在待处理问题 || （存在核验不通过问题 && 不存在待核验问题）） ===》   显示重新提醒处理按钮，否则不显示
                return remindStatus === 2 && (positionSecurityList.some(item => (item.disposeStatus === 1)) || (positionSecurityList.some(item => (item.disposeStatus === 4)) && positionSecurityList.every(item => (item.disposeStatus !== 2 && item.disposeStatus !== 5))));
            },
            onClick: (record, btnItem, that) => {
                that.remark.show(record, btnItem, () => {
                    submitHandleResult(record, btnItem, that);
                });
            }
        },
        {
            key: "ignoreAll",
            name: "全部忽略",
            type: 2,
            component: 'normalButton',
            sonChangeValue: 0,  //子需要改成什么状态的值
            mainChangeValue: 0,  //主需要改成什么状态的值
            showFun: (record, btnItem) => {
                let positionSecurityList = record?.positionSecurityList || [];
                return positionSecurityList.some(item => item.disposeStatus === 1) || false;
            },
            onClick: (record, btnItem, that) => {
                allHandle(record, btnItem, that);
            }
        },
        {
            key: "confirmIgnore",
            name: "确认忽略",
            type: 2,
            component: 'normalButton',
            sonChangeValue: 0,  //子需要改成什么状态的值
            mainChangeValue: 0,  //主需要改成什么状态的值
            showFun: (record, btnItem, that) => {
                if (that.state.detailData.disposeStatus === 0 || that.state.detailData.disposeStatus === 2 || that.state.detailData.disposeStatus === 3) {
                    return false;
                } else {
                    let positionSecurityList = record?.positionSecurityList || [];
                    return positionSecurityList.every(item => item.disposeStatus === 0) || false;
                }
            },
            onClick: (record, btnItem, that) => {
                allHandle(record, btnItem, that);
            }
        },
        {
            key: "pass",
            name: "核验通过",
            type: 2,
            component: 'normalButton',
            btnType: "primary",
            sonChangeValue: 3,
            mainChangeValue: 3,
            showFun: (record, btnItem, that) => {
                return record.disposeStatus === 2;
            },
            onClick: (record, btnItem, that) => {
                allHandle(record, btnItem, that)
            }
        }
    ]
}

// 0 已忽略   1 待处理    2 待核验   3 核验通过   4 核验不通过   5 非问题
// contribute首页列表按钮

export const getContributeListBtn = [
    {
        key: "submit",
        name: "提交结果",
        type: 2,
        component: 'textPopover',
        btnList: [
            {
                key: "handleAndSubmit",
                name: "已处理并提交",
                mainChangeValue: 2,
                onClick: (record, btnItem, that) => {
                    changeHomeListStatus(record, btnItem, that)
                }
            },
            {
                key: "noProblemAndSubmit",
                name: "非问题并提交",
                mainChangeValue: 5,
                onClick: (record, btnItem, that) => {
                    changeHomeListStatus(record, btnItem, that)
                }
            }
        ],
        showFun: (record, btnItem) => {
            let disposeStatus = record.disposeStatus;
            return disposeStatus === 1 || disposeStatus === 4;
        },
    },
    {
        key: "link",
        name: "原文链接",
        type: 2,
        component: 'text',
        onClick: (record, btnItem, that) => {
            window.open(record.url);
        }
    },
    {
        key: "view",
        name: "查看详情",
        type: 2,
        component: 'text',
        onClick: (record, btnItem, that) => {
            that.dangerDisposeDetail.show(record.id, () => {
                that.getListData();
            })
        }
    },
    {
        key: "goHandle",
        name: "去处理",
        type: 2,
        component: 'text',
        showFun: (record, btnItem) => {
            // 处置端，处置链接存在 && 待解决、核验不通过 显示
            return !!record.disposeLink && (record.disposeStatus === 1 || record.disposeStatus === 4);
        },
        onClick: (record, btnItem, that) => {
            let finalLink = record.disposeLink;
            // 判断链接中是否有https
            if (record.disposeLink.indexOf("https") === -1) {
                finalLink = `https://${record.disposeLink}`;
            }
            window.open(`${finalLink}`, '_blank');
        }
    },
]

// 0 已忽略   1 待处理    2 待核验   3 核验通过   4 核验不通过   5 非问题
// contribute查看详情弹窗底部按钮

export const getContributeDetailBottomBtn = [
    {
        key: "submitResult",
        name: "提交处理结果",
        type: 2,
        btnType: "primary",
        component: 'normalButton',
        mainChangeValue: 2,  //修改主状态为待核验
        showFun: (record, btnItem, that) => {
            if (that.state.detailData.disposeStatus === 0 || that.state.detailData.disposeStatus === 2 || that.state.detailData.disposeStatus === 3) {
                return false;
            } else if (that.state.detailData.disposeStatus === 1) {
                let positionSecurityList = record?.positionSecurityList || [];
                return positionSecurityList.every(item => item.disposeStatus !== 1) || false;
            } else if (that.state.detailData.disposeStatus === 4) {
                let positionSecurityList = record?.positionSecurityList || [];
                return positionSecurityList.every(item => item.disposeStatus === 0 || item.disposeStatus === 2 || item.disposeStatus === 3 || item.disposeStatus === 5) || false;
            }
        },
        onClick: (record, btnItem, that) => {
            submitHandleResult(record, btnItem, that)
        }
    },
]

// 0 已忽略   1 待处理    2 待核验   3 核验通过   4 核验不通过   5 非问题
// pms查看详情列表按钮

export const getPmsDetailListBtn = [
    {
        key: "noProblem",
        name: "忽略",
        type: 2,
        component: 'text',
        statusValue: 0,  //需要改成什么状态的值
        statusName: "已忽略", //需要改成什么状态的名称
        showFun: (record, btnItem, that) => {
            let disposeStatus = record.disposeStatus;
            if (that.state.detailData.disposeStatus === 1) {
                if (that.state.detailData.disposeStatus === 1) {
                    return disposeStatus === 1;
                } else if (that.state.detailData.disposeStatus === 2) {
                    return disposeStatus === 2 || disposeStatus === 3 || disposeStatus === 4;
                }
            }
        },
        onClick: (record, btnItem, that) => {
            that.refreshDetailListData(record, btnItem)
        }
    },
    {
        key: "cancelNoProblem",
        name: "取消忽略",
        type: 2,
        component: 'text',
        statusValue: 1,  //需要改成什么状态的值
        statusName: "待处理", //需要改成什么状态的名称
        showFun: (record, btnItem, that) => {
            let disposeStatus = record.disposeStatus;
            if (that.state.detailData.disposeStatus === 1) {
                return disposeStatus === 0;
            }
        },
        onClick: (record, btnItem, that) => {
            that.refreshDetailListData(record, btnItem)
        }
    },
    {
        key: "pass",
        name: "核验通过",
        type: 2,
        component: 'text',
        statusValue: 3,  //需要改成什么状态的值
        statusName: "核验通过", //需要改成什么状态的名称
        showFun: (record, btnItem, that) => {
            let disposeStatus = record.disposeStatus;
            if (that.state.detailData.disposeStatus === 2) {
                return disposeStatus === 2 || disposeStatus === 4 || disposeStatus === 5;
            }
        },
        onClick: (record, btnItem, that) => {
            that.refreshDetailListData(record, btnItem)
        }
    },
    {
        key: "noPass",
        name: "核验不通过",
        type: 2,
        component: 'text',
        statusValue: 4,  //需要改成什么状态的值
        statusName: "核验不通过", //需要改成什么状态的名称
        showFun: (record, btnItem, that) => {
            let disposeStatus = record.disposeStatus;
            if (that.state.detailData.disposeStatus === 2) {
                return disposeStatus === 2 || disposeStatus === 3 || disposeStatus === 5;
            }
        },
        onClick: (record, btnItem, that) => {
            that.refreshDetailListData(record, btnItem)
        }
    },
]

// 0 已忽略   1 待处理    2 待核验   3 核验通过   4 核验不通过   5 非问题
// contribute查看详情列表按钮

export const getContributeDetailListBtn = [
    {
        key: "handled",
        name: "已处理",
        type: 2,
        component: 'text',
        statusValue: 2,  //需要改成什么状态的值
        statusName: "已处理（待核验）", //需要改成什么状态的名称
        showFun: (record, btnItem, that) => {
            if (that.state.detailData.disposeStatus === 0 || that.state.detailData.disposeStatus === 2 || that.state.detailData.disposeStatus === 3) {
                return false;
            } else {
                let disposeStatus = record.disposeStatus;
                return disposeStatus === 1 || disposeStatus === 4 || disposeStatus === 5;
            }
        },
        onClick: (record, btnItem, that) => {
            that.refreshDetailListData(record, btnItem)
        }
    },
    {
        key: "noProblem",
        name: "无需处理",
        type: 2,
        component: 'text',
        statusValue: 5,  //需要改成什么状态的值
        statusName: "无需处理（待核验）", //需要改成什么状态的名称
        showFun: (record, btnItem, that) => {
            if (that.state.detailData.disposeStatus === 0 || that.state.detailData.disposeStatus === 2 || that.state.detailData.disposeStatus === 3) {
                return false;
            } else {
                let disposeStatus = record.disposeStatus;
                return disposeStatus === 1 || disposeStatus === 4 || disposeStatus === 2;
            }
        },
        onClick: (record, btnItem, that) => {
            that.refreshDetailListData(record, btnItem)
        }
    }
]

export const getPmsBatchConfig = (status) => {
    switch (status) {
        case 1:
            return {
                key: "batchIgnore",
                name: "批量忽略",
                child: [
                    {
                        name: "忽略",
                        style: {color: "#1082ff", marginLeft: "10px"},
                        onClick: (btnItem, that) => {
                            that.checkboxOperate(0, "已忽略")
                        }
                    },
                    {
                        name: "取消忽略",
                        style: {color: "#1082ff", marginLeft: "10px"},
                        onClick: (btnItem, that) => {
                            that.checkboxOperate(1, "待处理")
                        }
                    },
                    {
                        name: "取消",
                        style: {marginLeft: "10px"},
                        onClick: (btnItem, that) => {
                            that.setState({
                                toggleStatus: false
                            });
                            that.onCheckboxClick(false);
                        }
                    }]
            }
        case 2:
            return {
                key: "batchVerification",
                name: "批量核验",
                child: [
                    {
                        name: "核验通过",
                        style: {color: "#1082ff", marginLeft: "10px"},
                        onClick: (btnItem, that) => {
                            that.checkboxOperate(3, "核验通过")
                        }
                    },
                    {
                        name: "核验不通过",
                        style: {color: "#1082ff", marginLeft: "10px"},
                        onClick: (btnItem, that) => {
                            that.checkboxOperate(4, "核验不通过")
                        }
                    },
                    {
                        name: "取消",
                        style: {marginLeft: "10px"},
                        onClick: (btnItem, that) => {
                            that.setState({
                                toggleStatus: false
                            });
                            that.onCheckboxClick(false);
                        }
                    }]
            }
    }
}

export const getContributeBatchConfig = (status) => {
    switch (status) {
        case 1:
            return {
                key: "batchHandle",
                name: "批量处理",
                child: [
                    {
                        name: "已处理",
                        style: {color: "#1082ff", marginLeft: "10px"},
                        onClick: (btnItem, that) => {
                            that.checkboxOperate(2, "已处理（待核验）")
                        }
                    },
                    {
                        name: "无需处理",
                        style: {marginLeft: "10px"},
                        onClick: (btnItem, that) => {
                            that.checkboxOperate(5, "无需处理（待核验）")
                        }
                    },
                    {
                        name: "取消",
                        style: {marginLeft: "10px"},
                        onClick: (btnItem, that) => {
                            that.setState({
                                toggleStatus: false
                            })
                        }
                    }]
            }
        case 4:
            return {
                key: "batchHandle",
                name: "批量处理",
                child: [
                    {
                        name: "已处理",
                        style: {color: "#1082ff", marginLeft: "10px"},
                        onClick: (btnItem, that) => {
                            that.checkboxOperate(2, "已处理（待核验）")
                        }
                    },
                    {
                        name: "无需处理",
                        style: {marginLeft: "10px"},
                        onClick: (btnItem, that) => {
                            that.checkboxOperate(5, "无需处理（待核验）")
                        }
                    },
                    {
                        name: "取消",
                        style: {marginLeft: "10px"},
                        onClick: (btnItem, that) => {
                            that.setState({
                                toggleStatus: false
                            })
                        }
                    }]
            }
    }
}